import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { COMPOUND_ID_PREFIXES, SUBSTANCE_DETAILS_TOOLTIPS } from '@Constants/ElementConstants';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

export default class SubstanceIdentificationInformation extends React.PureComponent {
  render() {
    const { substance, database, onToggle } = this.props;
    const { details, sourceUrl } = substance;
    const mapped = SUBSTANCE_DETAILS_TOOLTIPS[database.id];
    const label = getValueByNs(mapped, 'id') || `${database.name} ID`;

    return (
      <div
        id='substance-identification-information'
        className='substance-results-information typography-small'
        aria-expanded={true}>
        <div className='sub-menu'>
          <i role='button' tabIndex='0' className='sub-menu-close ss-delete' onClick={onToggle}/>
          <div className='u-els-font-size-h3'>Identification</div>

          <table className='rx-substance-identification results-key-value-wrapper'>
            <colgroup>
              <col className='rx-substance-identification__heading'/>
              <col/>
              <col className='rx-substance-identification__heading'/>
              <col/>
            </colgroup>

            <tbody>
            {details.id &&
              <tr>
                <th scope='row'>{label}:</th>
                {sourceUrl ? (
                  <td>
                    <a href={sourceUrl} target='_blank'>
                      {getCompoundId(details.id, database)}
                    </a>
                  </td>
                ) : (
                  <InnerHTML
                    tag="td"
                    html={getCompoundId(details.id, database)}
                  />
                )}
              </tr>
            }
            {!isEmpty(details.casRegistryNumbers) &&
              <tr>
                <th scope='row'>CAS Registry Number(s):</th>
                <InnerHTML
                  tag="td"
                  html={isArray(details.casRegistryNumbers) ? details.casRegistryNumbers.join(', ') : details.casRegistryNumbers}
                />
              </tr>
            }
            {details.formula &&
              <tr>
                <th scope='row'>Molecular Formula:</th>
                <InnerHTML
                  tag="td"
                  html={details.formula}
                  mode="escape"
                />
              </tr>
            }
            {details.linearFormula &&
              <tr>
                <th scope='row'>Linear Structure Formula:</th>
                <InnerHTML
                  tag="td"
                  html={details.linearFormula}
                  mode="escape"
                />
              </tr>
            }
            {details.weight &&
              <tr>
                <th scope='row'>Molecular Weight:</th>
                <InnerHTML
                  tag="td"
                  html={details.weight}
                />
              </tr>
            }
            {details.inChiKey &&
              <tr>
                <th scope='row'>InChIKey:</th>
                <InnerHTML
                  tag="td"
                  html={details.inChiKey}
                />
              </tr>
            }
            {details.type &&
              <tr>
                <th scope='row'>Compound Type(s):</th>
                <InnerHTML
                  tag="td"
                  html={details.type.join(', ')}
                />
              </tr>
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

function getCompoundId(id, db) {
  const prefix = COMPOUND_ID_PREFIXES[db.databaseId];
  return prefix ? `${prefix}-${id}` : id;
}

SubstanceIdentificationInformation.propTypes = {
  database: PropTypes.object.isRequired,
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};
